<template>
  <v-card>
    <v-form @submit.prevent="submitEditContractor()" ref="editContractorForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="contractor.name"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedContractor.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* ABN"
              v-model="editedContractor.abn"
              :rules="abnRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Phone"
              v-model="editedContractor.contactPhone"
              :rules="contactPhoneRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="editedContractor.contactEmail"
              :rules="contactEmailRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Street address 1"
              v-model="editedContractor.addressStreet1"
              :rules="addressRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Street address 2"
              v-model="editedContractor.addressStreet2"
              :rules="addressRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              label="City"
              v-model="editedContractor.addressCity"
              :rules="addressCityRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              label="State"
              :items="states"
              v-model="editedContractor.addressState"
              no-data-text="An error occured"
              color="indigo"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              label="Post code"
              v-model="editedContractor.addressPostCode"
              :rules="addressPostCodeRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm6>
            <v-switch :color="$store.state.global.pages.contractor.color" label="Admin fee required" v-model="editedContractor.adminFeeRequired"></v-switch>
          </v-flex>-->
          <v-flex xs12 sm6>
            <v-text-field
              label="Admin fee percentage"
              v-model="editedContractor.adminFeePercentage"
              :rules="adminFeePercentageRules"
              type="number"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Sub-contractor Override"
              v-model="editedContractor.override"
              type="number"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              hint="This will affect Drivers and Vehicles under this Sub-Contractor"
              persistent-hint
              label="Active"
              :color="$store.state.global.pages.contractor.color"
              v-model="editedContractor.active"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm6 v-if="$store.state.user.userAuthClass.name === 'Administrator'">
            <v-switch
              label="Request"
              :color="$store.state.global.pages.contractor.color"
              v-model="editedContractor.request"
              :disabled="!userAuthClass"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :currentProjects="currentProjects"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @discard="discarding = false"
      v-if="initData"
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ContractorService from '@/services/requests/contractorService'
import ContractorProjectService from '@/services/requests/contractorProjectService'

// MIXINS
import ContractorValidation from '@/services/validation/contractorValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import InductionsPanel from '@/components/ui/inductionsPanel'

export default {
  mixins: [ContractorValidation],
  components: {
    DialogHeader,
    InductionsPanel,
  },
  data() {
    return {
      editedContractor: Object.assign({}, this.contractor),
      loading: false,
      states: ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NT', 'ACT'],
      selectedProjects: [],
      currentProjects: [],
      discarding: false,
      initData: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.discarding = true
      this.editedContractor = Object.assign({}, this.contractor)
      this.selectedProjects = [...this.currentProjects]
      this.close()
    },
    submitEditContractor() {
      if (!this.$refs.editContractorForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    getContractorProjectsByContractor() {
      ContractorProjectService.getContractorProjectsByContractor(
        this.contractor.id
      )
        .then((result) => {
          this.setCurrentProjects(result.data.result)
          this.initData = true
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentProjects(data) {
      this.selectedProjects = []
      this.currentProjects = []
      for (var record of data) {
        this.selectedProjects.push(record.projectId)
        this.currentProjects.push(record.projectId)
      }
    },
    save() {
      var postedContractor = this.editedContractor
      postedContractor.selectedProjects = this.selectedProjects
      this.loading = true
      ContractorService.updateContractor(this.editedContractor)
        .then((result) => {
          this.loading = false
          this.$store.commit('contractors/updateArrayStateByValue', {
            prop: 'contractors',
            value: this.contractor,
            editedValue: result.data.result.contractor,
          })
          this.editedContractor = Object.assign(
            {},
            result.data.result.contractor
          )
          this.setCurrentProjects(result.data.result.contractorProjects)
          this.snack({ text: 'Contractor was edited!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
  },
  computed: {
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    different() {
      if (
        !this._.isEqual(this.contractor, this.editedContractor) ||
        !this._.isEqual(
          this.selectedProjects.sort().join(','),
          this.currentProjects.sort().join(',')
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.getContractorProjectsByContractor()
  },
  props: {
    contractor: Object,
  },
}
</script>

<style>
</style>
